<template>
  <div class="col-lg-3 col-sm-12 ">
    <img :src="data.img" alt="" class="p-5" width="100%">
    <h3 class="text-center">{{data.titulo}}</h3>
    <p class="px-4 text-justify" v-html="data.descripcion"></p>
  </div>
</template>

<script>
  export default {
    name: "Card",
    props: {
      data: {type: Object, required: true}
    }
  }
</script>

<style scoped>
  .col-lg-3:hover {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2), 0 6px 7px 0 rgba(0, 0, 0, .7) !important;
  }

  .col-md-6:hover {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2), 0 6px 7px 0 rgba(0, 0, 0, .7) !important;
  }
</style>
